import React, { useEffect, Fragment } from 'react';

const Auth = (props) => {
    
    const urlSearchParams = new URLSearchParams(props.location.search);

    const redirectUrl = urlSearchParams.get('redirect');

    const redirect = () =>{
        props.history.push("/"+redirectUrl);
    }

    useEffect(()=> {

        const publicToken = urlSearchParams.get('public_token');
        const token = urlSearchParams.get('token');

        if(publicToken && token){
            localStorage.public_token = publicToken;
            localStorage.token = token;
            redirect();
        }

    },[])
    return <Fragment/>;
}

export default Auth;


// WEBPACK FOOTER //
// ./src/components/AuthComponent/AuthComponent.js